





















































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  CUSTOMER_MARITAL_STATUS_LABELS,
  CUSTOMER_SALUTATION_LABELS,
  CUSTOMER_STATUS_LABELS,
  CustomerStatus,
  CustomerType,
  CUSTOMER_TYPE_LABELS,
  IDamage,
  ICustomerListItem,
  IPolicy,
  ITask,
  PolicyStatus,
  TaskStatus,
} from 'admiral-core';
import {
  BookIcon,
  CheckSquareIcon,
  CloudDrizzleIcon,
  FileTextIcon,
  ListIcon,
  PlusIcon,
} from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { CommentApi } from '@/services/CommentApi';
import { CustomerApi } from '@/services/CustomerApi';
import { DamageApi } from '@/services/DamageApi';
import { TaskApi } from '@/services/TaskApi';
import EditCustomerModal from '@/views/pages/customers/EditCustomerModal.vue';
import CreatePolicyModal from '@/views/pages/policies/CreatePolicyModal.vue';
import CommentBox from '@/components/common/CommentBox.vue';
import OverviewStatisticCard from '@/components/common/OverviewStatisticCard.vue';
import PoliciesOverview from '@/views/pages/policies/PoliciesOverview.vue';
import DamageOverview from '@/views/pages/damages/DamageOverview.vue';
import EditDamageModal from '@/views/pages/damages/EditDamageModal.vue';
import CreateTaskModal from '@/views/pages/tasks2/CreateTaskModal.vue';
import EditTaskModal from '@/views/pages/tasks2/EditTaskModal.vue';
import PolicyEmbeddedTaskList from '@/components/tasks/PolicyEmbeddedTaskList.vue';
import {
  formatCustomerAddress,
  formatCustomerPhones,
  hasCustomerAddress,
} from '@/utils/formatCustomerAddress';
import { BModal } from 'bootstrap-vue';
import dayjs from 'dayjs';

type CustomerDetailSection = 'policies' | 'antraege' | 'damages' | 'tasks' | 'comments';

type CustomerDetailTab = {
  id: CustomerDetailSection;
  label: string;
  count: number | null;
  icon?: 'list' | 'antraege' | 'damages' | 'tasks';
};

@Component({
  name: 'customer-detail',
  components: {
    EditCustomerModal,
    CreatePolicyModal,
    CommentBox,
    OverviewStatisticCard,
    PoliciesOverview,
    DamageOverview,
    EditDamageModal,
    CreateTaskModal,
    EditTaskModal,
    PolicyEmbeddedTaskList,
    PlusIcon,
    ListIcon,
    BookIcon,
    FileTextIcon,
    CloudDrizzleIcon,
    CheckSquareIcon,
  },
})
export default class CustomerDetail extends mixins(BaseMixin) {
  CustomerType = CustomerType;

  customer: ICustomerListItem | null = null;
  isLoading = false;
  activeSection: CustomerDetailSection = 'policies';
  damages: IDamage[] = [];
  tasks: ITask[] = [];
  damagesLoading = false;
  tasksLoading = false;
  damagesLoaded = false;
  tasksLoaded = false;
  selectedDamage: IDamage | null = null;
  selectedTask: ITask | null = null;
  commentsCount = 0;

  customerPolicyColumns = [
    'updatedAt',
    'status',
    'product',
    'tags',
    'user',
    'value',
    'quantity',
  ];

  get customerId(): string {
    return this.$route.params.id;
  }

  get linkedPolicies(): IPolicy[] {
    return this.customer?.policies || [];
  }

  /** Anbahnungen: alle Status außer POLICED (gehört zu Tab „Anträge“). */
  get anbahnungenPolicies(): IPolicy[] {
    return this.linkedPolicies.filter((policy) => policy.status !== PolicyStatus.POLICED);
  }

  get anbahnungenCount(): number {
    return this.anbahnungenPolicies.length;
  }

  /** Policierte Anbahnungen (Tab „Anträge“). */
  get antraegePolicies(): IPolicy[] {
    return this.linkedPolicies.filter((policy) => policy.status === PolicyStatus.POLICED);
  }

  get displayName(): string {
    if (!this.customer) {
      return '–';
    }
    if (this.customer.type === CustomerType.LEGAL) {
      return this.customer.name || '–';
    }
    const parts = [this.customer.firstname, this.customer.lastname].filter(Boolean);
    return parts.length ? parts.join(' ') : '–';
  }

  get customerInitials(): string {
    if (!this.customer) {
      return '?';
    }
    if (this.customer.type === CustomerType.LEGAL) {
      const name = (this.customer.name || '').trim();
      return name.slice(0, 2).toUpperCase() || 'K';
    }
    const first = (this.customer.firstname || '').trim().charAt(0);
    const last = (this.customer.lastname || '').trim().charAt(0);
    return `${first}${last}`.toUpperCase() || '?';
  }

  get customerSinceLabel(): string {
    if (!this.customer?.createdAt) {
      return '';
    }
    return dayjs(this.customer.createdAt).format('DD.MM.YYYY');
  }

  get displayPhone(): string {
    if (!this.customer) {
      return '–';
    }
    return formatCustomerPhones(this.customer);
  }

  get hasAddress(): boolean {
    return this.customer ? hasCustomerAddress(this.customer) : false;
  }

  get formattedAddress(): string {
    return this.customer ? formatCustomerAddress(this.customer) : '';
  }

  get formatBirthDate(): string {
    if (!this.customer?.birthDate) {
      return '–';
    }
    return dayjs(this.customer.birthDate).format('DD.MM.YYYY');
  }

  get salutationLabel(): string {
    const salutation = this.customer?.salutation;
    if (!salutation) {
      return '–';
    }
    return CUSTOMER_SALUTATION_LABELS[salutation] || '–';
  }

  get maritalStatusLabel(): string {
    const maritalStatus = this.customer?.maritalStatus;
    if (!maritalStatus) {
      return '–';
    }
    return CUSTOMER_MARITAL_STATUS_LABELS[maritalStatus] || '–';
  }

  /** Anzeigename des zugewiesenen Mitarbeiters. */
  get mitarbeiterName(): string {
    const user = this.customer?.user;
    if (!user) {
      return '–';
    }
    const parts = [user.firstname, user.lastname].filter(Boolean);
    return parts.length ? parts.join(' ') : '–';
  }

  /** Bezeichnung für Anbahnungs-Bewertung (Agentur-Einstellung, z. B. „Bewertung“). */
  get policyValueWording(): string {
    return this.agency?.wording?.value || 'Bewertung';
  }

  get anbahnungenPointsSum(): number {
    return this.sumPolicyValue(this.anbahnungenPolicies);
  }

  get anbahnungenPointsSumLabel(): string {
    return this.anbahnungenPointsSum.toLocaleString('de-DE');
  }

  get antraegePointsSum(): number {
    return this.sumPolicyValue(this.antraegePolicies);
  }

  get antraegePointsSumLabel(): string {
    return this.antraegePointsSum.toLocaleString('de-DE');
  }

  get antraegeCount(): number {
    return this.antraegePolicies.length;
  }

  /** Summiert die Bewertungspunkte einer Anbahnungsliste. */
  sumPolicyValue(policies: IPolicy[]): number {
    return policies.reduce((sum, policy) => sum + (Number(policy.value) || 0), 0);
  }

  get openTasksCount(): number {
    return this.customerTasks.filter((task) => task.status === TaskStatus.TODO).length;
  }

  get sectionTabs(): CustomerDetailTab[] {
    return [
      {
        id: 'policies',
        label: 'Anbahnungen',
        count: this.anbahnungenCount,
        icon: 'list',
      },
      {
        id: 'antraege',
        label: 'Anträge',
        count: this.antraegeCount,
        icon: 'antraege',
      },
      {
        id: 'damages',
        label: 'Schäden',
        count: this.damagesLoaded
          ? this.customerDamages.length
          : this.customer?.damageCount ?? 0,
        icon: 'damages',
      },
      {
        id: 'tasks',
        label: 'Aufgaben',
        count: this.tasksLoaded ? this.customerTasks.length : this.customer?.taskCount ?? 0,
        icon: 'tasks',
      },
      { id: 'comments', label: 'Kommentare', count: this.commentsCount },
    ];
  }

  get showDemo(): boolean {
    return this.$store.getters['PreferencesModule/getShowDemo'];
  }

  get customerLegacyName(): string {
    if (!this.customer) {
      return '';
    }
    if (this.customer.type === CustomerType.LEGAL) {
      return this.normalizeCustomerName(this.customer.name || '');
    }
    const parts = [this.customer.firstname, this.customer.lastname].filter(Boolean).join(' ');
    return this.normalizeCustomerName(parts);
  }

  get customerDamages(): IDamage[] {
    const legacy = this.customerLegacyName;
    if (!legacy) {
      return [];
    }
    return this.damages.filter(
      (damage) => this.normalizeCustomerName(damage.customer || '') === legacy,
    );
  }

  get customerTasks(): ITask[] {
    const policyIds = new Set(this.linkedPolicies.map((policy) => policy.id));
    const legacy = this.customerLegacyName;

    return this.tasks.filter((task) => {
      if (task.customerId === this.customerId) {
        return true;
      }
      if (task.policies?.some((policy) => policyIds.has(policy.id))) {
        return true;
      }
      return task.damages?.some(
        (damage) => this.normalizeCustomerName(damage.customer || '') === legacy,
      );
    });
  }

  async mounted() {
    await this.loadCustomer();
  }

  @Watch('customerId')
  async onCustomerIdChange() {
    this.resetSectionData();
    await this.loadCustomer();
  }

  async loadCustomer() {
    if (!this.customerId) {
      this.customer = null;
      return;
    }
    this.isLoading = true;
    try {
      const response = await CustomerApi.getCustomer({
        id: this.customerId,
        agency: this.agency,
        showDemo: this.showDemo,
      });
      this.customer = response.data;
      void this.loadCustomerComments();
    } catch (e) {
      console.log(e);
      this.customer = null;
      this.$toastr.e('Kunde konnte nicht geladen werden.');
    } finally {
      this.isLoading = false;
    }
  }

  setActiveSection(section: CustomerDetailSection) {
    this.activeSection = section;
    if (section === 'damages' && !this.damagesLoaded) {
      void this.loadCustomerDamages();
    }
    if (section === 'tasks' && !this.tasksLoaded) {
      void this.loadCustomerTasks();
    }
  }

  resetSectionData() {
    this.damages = [];
    this.tasks = [];
    this.damagesLoaded = false;
    this.tasksLoaded = false;
    this.selectedDamage = null;
    this.selectedTask = null;
    this.commentsCount = 0;
    this.activeSection = 'policies';
  }

  /** Kommentaranzahl für Tab-Badge (wird von CommentBox bei Änderungen aktualisiert). */
  async loadCustomerComments() {
    if (!this.customerId) {
      this.commentsCount = 0;
      return;
    }
    try {
      const response = await CommentApi.get({ customerId: this.customerId });
      this.commentsCount = response.data.length;
    } catch {
      this.commentsCount = 0;
    }
  }

  normalizeCustomerName(name: string): string {
    return name.trim().toLowerCase().replace(/\s+/g, ' ');
  }

  async loadCustomerDamages() {
    this.damagesLoading = true;
    try {
      const response = await DamageApi.getDamages({
        agency: this.agency,
        showDemo: this.showDemo,
      });
      this.damages = response.data;
      this.damagesLoaded = true;
    } catch (e) {
      console.log(e);
      this.$toastr.e('Schäden konnten nicht geladen werden.');
    } finally {
      this.damagesLoading = false;
    }
  }

  async loadCustomerTasks() {
    this.tasksLoading = true;
    try {
      const response = await TaskApi.getTasks({
        agency: this.agency,
        showDemo: this.showDemo,
        status: [
          TaskStatus.TODO,
          TaskStatus.IN_PROGRESS,
          TaskStatus.IN_WAITING,
          TaskStatus.COMPLETED,
          TaskStatus.ARCHIVED,
        ],
      });
      this.tasks = response.data;
      this.tasksLoaded = true;
    } catch (e) {
      console.log(e);
      this.$toastr.e('Aufgaben konnten nicht geladen werden.');
    } finally {
      this.tasksLoading = false;
    }
  }

  async openDamageById(id: string) {
    try {
      const response = await DamageApi.getDamage(id);
      this.selectedDamage = response.data;
      this.$nextTick(() => {
        this.showNestedModal('edit-damage-modal', 'edit-damage');
      });
    } catch (e) {
      console.log(e);
      this.$toastr.e('Schaden konnte nicht geladen werden.');
    }
  }

  openTask(task: ITask) {
    this.selectedTask = task;
    this.$nextTick(() => {
      this.showNestedModal('edit-task-modal', 'edit-task');
    });
  }

  showNestedModal(parentRef: string, modalRef: string) {
    const parent = this.$refs[parentRef] as Vue & { $refs: { [key: string]: BModal } };
    parent.$refs[modalRef].show();
  }

  goToList() {
    this.$router.push({ name: 'customers' }).catch(() => {
      //
    });
  }

  openEditModal() {
    const modal = (this.$refs['edit-customer-modal'] as EditCustomerModal).$refs[
      'edit-customer'
    ] as BModal;
    modal.show();
  }

  /** Öffnet Aufgabe anlegen mit Verknüpfung zum aktuellen CRM-Kunden. */
  openCreateTask() {
    if (!this.customerId) {
      return;
    }
    (this.$refs['create-task-modal'] as any).showWithCustomer(this.customerId);
  }

  /** Öffnet Anbahnung anlegen mit vorausgefülltem Kundennamen. */
  openCreatePolicy() {
    const modal = this.$refs['create-policy-modal'] as any;
    const customerName = this.customerLegacyName
      ? this.customerLegacyName
          .split(' ')
          .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
          .join(' ')
      : this.displayName;
    modal.model = {
      ...modal.defaultModel(),
      customer: customerName,
    };
    (modal.$refs['create-policy'] as BModal).show();
  }

  typeLabel(type: CustomerType): string {
    return CUSTOMER_TYPE_LABELS[type];
  }

  statusLabel(status: CustomerStatus): string {
    return CUSTOMER_STATUS_LABELS[status] || status;
  }

  statusBadgeClass(status: CustomerStatus): string {
    const classes: Record<CustomerStatus, string> = {
      [CustomerStatus.ACTIVE]: 'customer-status-pill--active',
      [CustomerStatus.INACTIVE]: 'customer-status-pill--inactive',
      [CustomerStatus.ARCHIVED]: 'customer-status-pill--archived',
    };
    return classes[status] || 'customer-status-pill--inactive';
  }
}
